// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"833":"08496a7e4ce21c4ffbc1","913":"52f14fc50b05d5eadc94","926":"5f6fb67fad17f23d2cbd"}[chunkId] + ".chunk.js";
};